"use strict";

define('rs/form/formobjects/textbox/textbox.formobject',['rs/form/formobjects/base.formobject', 'rs/form/formobjects/textbox/textbox.formobject.view'], function (BaseFormObject, TextboxFormObjectView) {
  var TextboxFormObject = BaseFormObject.extend({
    defaultValue: '',
    propertiesDefinitions: ['name', 'required', 'label', 'text', 'description', 'helpText'],
    linksDefinitions: ['link.displayed', 'link.required'],
    isAnswerable: true,
    setupView: function setupView() {
      this.setView(new TextboxFormObjectView());
    },
    getCompareValue: function getCompareValue() {
      return this.getValue() || '';
    }
  }, {
    getTypeString: function getTypeString() {
      return 'TextBox';
    }
  });
  return TextboxFormObject;
});

